import { deepMerge } from 'js/utils/Utils'
import { PlaneGeometry } from 'three'

import BgColorPlaneMesh from 'js/webgl/customMeshes/BgColorPlaneMesh'
import BannerAPlaneMesh from 'js/webgl/customMeshes/BannerAPlaneMesh'

const defaults = {
  instanceName: 'contactWebgl',
  $names: {
    bg: '[data-gl-item="bg"]',
    bannerA: '[data-gl-item="banner-a"]',
  },
  dataNames: {},
}

export default class ContactWebgl {
  $contentRoot = document
  $bgs = []
  $bannerAs = []
  meshesItems = []

  bgMeshes = []
  bannerAMeshes = []
  originalPlaneGeometry = null

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setMeshes()
    this._addEventListeners()
    this._addGUI()
  }

  destroy() {
    this._removeGUI()
    this._removeEventListeners()
    this._clearMesh()
  }

  _set$() {
    this.$bgs = this.$contentRoot.querySelectorAll(this.$names.bg)
    this.$bannerAs = this.$contentRoot.querySelectorAll(this.$names.bannerA)
  }

  _setMeshes() {
    this.meshesItems = []
    this.originalPlaneGeometry = new PlaneGeometry(1, 1, 1, 1)

    this.bgMeshes = []
    this.$bgs.forEach(($bg, i) => {
      this.bgMeshes[i] = new BgColorPlaneMesh({
        webgl: this,
        $target: $bg,
        geometry: this.originalPlaneGeometry,
        instanceName: `companyWebgl-bg-${i}`,
        index: i,
      })
    })

    this.bannerAMeshes = []
    this.$bannerAs.forEach(($bannerA, i) => {
      this.bannerAMeshes[i] = new BannerAPlaneMesh({
        webgl: this,
        $target: $bannerA,
        geometry: this.originalPlaneGeometry,
        instanceName: `companyWebgl-bannerA-${i}`,
        index: i,
      })
    })

    this.meshesItems.push(this.bgMeshes)
    this.meshesItems.push(this.bannerAMeshes)

    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.init()
      })
    })

    if (this.originalPlaneGeometry) {
      this.originalPlaneGeometry.dispose()
      this.originalPlaneGeometry = null
    }
  }

  _clearMesh() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.destroy()
        mesh = null
      })
    })
    this.meshesItems = []
  }

  _addEventListeners() {}

  _removeEventListeners() {}

  fvAnimation() {
    // this.bgXLMeshes[0]?.fvAnimation()
    if (this.slideshowBMeshes[0]) {
      this.slideshowBMeshes[0]?.fvAnimation()
    }
  }

  onResize() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onResize()
      })
    })
  }

  onRaf() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onRaf()
      })
    })
  }

  _addGUI() {
    // const meshes = []
    // meshes.forEach((mesh) => {
    //   if (mesh && mesh._addGUI) {
    //     mesh._addGUI()
    //   }
    // })
  }

  _removeGUI() {
    // this.meshesItems.forEach((meshesItem) => {
    //   meshesItem.forEach((mesh) => {
    //     mesh._removeGUI()
    //   })
    // })
  }
}